import { NationalList } from '@nxsys/constants/countries';
import React, { useEffect } from 'react';
import StepCard from './StepCard';
import { Form } from 'antd';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import { StyledAppSelect } from '@nxsys/components/AppSelect/index.styled';
import { useIntl } from 'react-intl';

interface AddNationalityProps {
  stepNumber: number;
  nationality?: string | null;
  onChangeNationality?: (value: string) => void;
  completed?: boolean;
  onSubmitStep: (values: any) => void;
}

type AddNationalityValues = {
  nationalityValue: string;
};

const AddNationality: React.FC<AddNationalityProps> = ({
  stepNumber,
  nationality,
  onChangeNationality,
  completed = false,
  onSubmitStep,
}) => {
  const [form] = Form.useForm<AddNationalityValues>();
  const { messages } = useIntl();

  // `nationality` is lifted into state in useOnboardingSteps and only filled in
  // by an effect once the payload lands, so it is still null on the first render
  // of this card. antd reads `initialValues` at mount only, hence the re-sync.
  useEffect(() => {
    form.setFieldsValue({ nationalityValue: nationality ?? undefined });
  }, [nationality, form]);

  const onFinish = async (values: AddNationalityValues) => {
    const params = {
      nationality: values.nationalityValue,
    }
    await onSubmitStep(params);
    onChangeNationality?.(values.nationalityValue);
  };

  return (
    <StepCard
      title={messages['prospect.onboarding.addNationality'] as string}
      stepNumber={stepNumber}
      completed={completed}
      actions={[
        {
          variant: 'outlined',
          name: messages['common.save'] as string,
          onClick: () => form.submit(),
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        initialValues={{
          nationalityValue: nationality,
        }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
      >
        <Form.Item
          label={messages['prospect.onboarding.nationality'] as string}
          name="nationalityValue"
          rules={[
            {
              required: true,
              message: messages['prospect.onboarding.nationality.required'] as string,
            },
          ]}
        >
          <StyledAppSelect showSearch placeholder={messages['prospect.onboarding.nationality.placeholder'] as string} options={NationalList} />
        </Form.Item>
      </AppFormContainer>
    </StepCard>
  );
};

export default AddNationality;
